import React from "react";

const DeviceIcon = ({ fill = "#387CFF", stroke = "#387CFF", ...props }) => (
  <svg
    width="19"
    height="19"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props} // Spread additional props (e.g., className, style)
  >
    <path
      d="M17 4V3C17 2.44772 16.5523 2 16 2H2C1.44772 2 1 2.44771 1 3V12C1 12.5523 1.44772 13 2 13H8.5"
      stroke={fill}
      strokeWidth="1.13"
      strokeLinecap="round"
    />
    <rect
      x="11"
      y="6"
      width="6"
      height="10"
      rx="1"
      stroke={fill}
      strokeWidth="1.13"
    />
    <circle cx="14" cy="14" r="1" fill={fill} />
    <path
      d="M4 15.5253L8.50781 15.5253"
      stroke={fill}
      strokeWidth="1.13"
      strokeLinecap="round"
    />
  </svg>
);
export default DeviceIcon;
